module.exports = __webpack_public_path__ + "img/img13.abc50c8d.svg";